import type { IconNode } from '../types';

/**
 * @name tie
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMi45IDNjLjEtLjYuNS0xIDEuMS0xaDRjLjYgMCAxIC40IDEuMSAxbC45IDE1LTQgNC00LTRaIiAvPgogIDxwYXRoIGQ9Ik04Ljg1IDIuNCAxNiAxMS44IiAvPgogIDxwYXRoIGQ9Im05LjcgMTMuMTUgNi41IDguNSIgLz4KICA8cGF0aCBkPSJNMjIgNXYxNmMwIC42LS40IDEtMSAxaC00Yy0uNiAwLTEtLjQtMS0xVjVsMy0zWiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/tie
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const tie: IconNode = [
  ['path', { d: 'M2.9 3c.1-.6.5-1 1.1-1h4c.6 0 1 .4 1.1 1l.9 15-4 4-4-4Z', key: '1kimmu' }],
  ['path', { d: 'M8.85 2.4 16 11.8', key: '10075x' }],
  ['path', { d: 'm9.7 13.15 6.5 8.5', key: '1loi63' }],
  ['path', { d: 'M22 5v16c0 .6-.4 1-1 1h-4c-.6 0-1-.4-1-1V5l3-3Z', key: 'xxl9lj' }],
];

export default tie;
